// Resolve the backend API URL safely.
//
// In production, the frontend and backend live on the same origin behind a
// Kubernetes ingress that routes `/api/*` to the backend. A stale build-time
// `REACT_APP_BACKEND_URL` (e.g. pointing to an old preview host) will cause
// CORS errors when the page is later served from a different domain like
// `aivoracomply360.com`.
//
// Strategy:
//  1. If running in a browser (window defined) and the env URL has a different
//     origin than the current page, prefer the current origin. This always
//     produces same-origin requests and side-steps CORS.
//  2. Otherwise use the env URL (covers SSR, tests, and intentional dev
//     overrides where the env URL matches the page origin).
//  3. Fallback to empty string -> relative `/api/...` calls.

const ENV_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

const isBrowser = typeof window !== 'undefined' && !!window.location;

function resolveApiUrl() {
  if (!isBrowser) return ENV_URL || '';

  const pageOrigin = window.location.origin.replace(/\/+$/, '');

  if (!ENV_URL) return pageOrigin;

  try {
    const envOrigin = new URL(ENV_URL).origin;
    if (envOrigin !== pageOrigin) {
      // Stale or cross-origin env URL → prefer the page origin so requests
      // stay same-origin and bypass CORS entirely.
      return pageOrigin;
    }
  } catch {
    // Invalid env URL → just use the page origin
    return pageOrigin;
  }

  return ENV_URL;
}

export const API_URL = resolveApiUrl();
export default API_URL;
